import TableWidget from './TableWidget'; 

export default TableWidget;